import script from "./ModalContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalContent.vue?vue&type=script&lang=ts&setup=true"

import "./ModalContent.vue?vue&type=style&index=0&id=12426aa4&lang=scss"

const __exports__ = script;

export default __exports__